import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useCheckoutStore = create(
  persist(
    (set) => ({
      item: null,
      addItem: (itemId, variantId, quantity) => set({ item: { itemId, variantId, quantity } }),
      removeItem: () => set({ item: null }),
      discount: null,
      addDiscount: (id, code) => set({ discount: { id, code }}),
      removeDiscount: () => set({ discount: null }),
    }),
    {
      name: 'checkout-storage'
    }
  )
);

export default useCheckoutStore;